<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <PageHeader :title="title" :items="items"/>
                <b-card>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label class="col-form-label col-form-label-sm" for="name">Name</label>
                                <input v-model="search_data.name" type="text" class="form-control form-control-sm"
                                       placeholder="Search by Name" id="name"/>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label class="col-form-label col-form-label-sm" for="nid">National ID</label>
                                <input v-model="search_data.nid" type="text" class="form-control form-control-sm"
                                       placeholder="Search by National ID" id="nid"/>
                            </div>
                          <div class="col-md-6 col-sm-6 col-lg-3">
                            <label class="col-form-label col-form-label-sm" for="district_id">District</label>
                            <select v-model="search_data.district_id" class="form-control form-control-sm" name="district_id" id="district_id">
                              <option selected :value="''">Select a District</option>
                              <option v-for="(district, index) in districts" :key="index" :value="district.id">{{district.id }} : {{ district.district_desc }}</option>
                            </select>
                          </div>
                          <div class="col-md-6 col-sm-6 col-lg-3">
                            <label class="col-form-label col-form-label-sm" for="upazila_id">Upazila</label>
                            <select v-model="search_data.upazila_id" class="form-control form-control-sm" name="upazila_id" id="upazila_id">
                              <option selected :value="''">Select a Upazila</option>
                              <option v-for="(upazila, index) in upazilas" :key="index" :value="upazila.id">{{upazila.id }} : {{ upazila.upazila_desc }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="form-row mt-1">
                          <div class="col-md-6 col-sm-6 col-lg-3">
                            <label class="col-form-label col-form-label-sm" for="union_id">Union</label>
                            <select v-model="search_data.union_id" class="form-control form-control-sm" name="union_id" id="union_id">
                              <option selected :value="''">Select a Union</option>
                              <option v-for="(union, index) in unions" :key="index" :value="union.id">{{union.id }} : {{ union.union_desc }}</option>
                            </select>
                          </div>
                          <div class="col-md-6 col-sm-6 col-lg-3">
                            <label class="col-form-label col-form-label-sm"  for="mouza_id">Mouza</label>
                            <select v-model="search_data.mouza_id" class="form-control form-control-sm" name="mouza_id" id="mouza_id">
                              <option selected :value="''">Select a Mouza</option>
                              <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{mouza.id }} : {{ mouza.mouza_desc }}</option>
                            </select>
                          </div>
                          <div class="col-md-6 col-sm-6 col-lg-3">
                            <label class="col-form-label col-form-label-sm" for="village_id">Village</label>
                            <select v-model="search_data.village_id" class="form-control form-control-sm" name="village_id" id="village_id">
                              <option selected :value="''">Select a Village</option>
                              <option v-for="(village, index) in villages" :key="index" :value="village.id">{{village.id }} : {{ village.village_desc }}</option>
                            </select>
                          </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>
                    </form>
                </b-card>

                <b-card>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>EP ID</th>
                                <th>Name</th>
                                <th>Father's Name</th>
                                <th>Area/Location</th>
                                <th>Village</th>
                                <th>Union/Ward</th>
                                <th>Mouza</th>
                                <th>Upazila</th>
                                <th>District</th>
                                <th>Division</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(ses, index) in seses.data" :key="index">
                                <td>{{ seses.from + index }}</td>
                                <td><span v-if="(ses.ep_id !== null)">{{ ses.ep_id.ep_id }}</span></td>
                                <td>
                                    <router-link :to="{ name: 'sesView',params: { ses_id: ses.id }}" tag="a" target="_blank">{{ ses.name }}</router-link>
                                </td>
                                <td>{{ ses.father_husband_name }}</td>
                                <td><span v-if="(ses.present_address !== null)">{{ ses.present_address.area_location }}</span></td>
                                <td><span v-if="(ses.present_address !== null)">{{ ses.present_address.village }}</span></td>
                                <td><span v-if="(ses.present_address !== null)">{{ ses.present_address.union_ward }}</span></td>
                                <td><span v-if="(ses.present_address !== null)">{{ ses.present_address.mouza }}</span></td>
                                <td><span v-if="(ses.present_address !== null)">{{ ses.present_address.upazila }}</span></td>
                                <td><span v-if="(ses.present_address !== null)">{{ ses.present_address.district }}</span></td>
                                <td><span v-if="(ses.present_address !== null)">{{ ses.present_address.division }}</span></td>
                                <td>
                                    <a v-if="(ses.present_address !== null)"
                                       @click.prevent="updatePresentAddressModal(ses.present_address, ses.id)" class="action-icon"
                                       href="javascript:void(0);" title="Update Present Address">
                                        <i class="mdi mdi-square-edit-outline editButton"></i>
                                    </a>
                                    <a v-else @click.prevent="addPresentAddressModal(ses.id)" class="action-icon"
                                       href="javascript:void(0);" title="Create Present Address">
                                        <i class="mdi mdi-plus-box addButton"></i>
                                    </a>
                                    <a v-if="(ses.present_address !== null)"
                                       @click.prevent="deletePresentAddress(ses.present_address.id)" class="action-icon"
                                       href="javascript:void(0);" title="Delete Present Address">
                                        <i class="mdi mdi-delete deleteButton"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="loader" class="loader">Loading...</div>
                        <h5 class="text-center text-secondary" v-if="seses.total === 0 || !flag">
                          No Data Found
                        </h5>
                        <div class="float-right mt-1">
                            <pagination :data="seses" :limit="2" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
        <present-address-modal
                :present_address="present_address"
                :btn_edit="btn_edit"
                @search="search">
        </present-address-modal>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import presentAddressModal from "@views/data/modals/presentAddressModal";

    export default {
        page: {
            title: "SES List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, presentAddressModal},
        data() {
            return {
                title: "Search SES",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "SES List",
                        active: true
                    }
                ],
                seses: {},
                present_address: {},
                search_data: {
                    name: '',
                    nid: '',
                    district_id: '',
                    upazila_id: '',
                    union_id: '',
                    mouza_id: '',
                    village_id: '',
                },
                districts: [],
                all_upazilas: [],
                all_unions: [],
                all_mouzas: [],
                all_villages: [],
                btn_edit: false,
                flag: false,
                loader: false
            };
        },

        mounted() {
            this.getCodes();
        },
        methods: {
            getCodes() {
                http.get("api/ses/present-address/codes").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.districts = data.districts;
                        this.all_upazilas = data.upazilas;
                        this.all_unions = data.unions;
                        this.all_mouzas = data.mouzas;
                        this.all_villages = data.villages;
                    }
                });
            },
            search() {
                this.flag = true
                this.loader = true
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http.post("api/ses/present-address/search", this.search_data).then(response => {
                            if (!response.error) {
                                this.flag = true;
                                this.loader = false
                                this.seses = response.data.seses;
                            }
                        });
                    }
                });
            },
            getResults(page = 1) {
                this.flag = true
                this.loader = true
                http.post('api/ses/present-address/search?page=' + page, this.search_data)
                    .then(response => {
                        this.flag = true;
                        this.loader = false
                        this.seses = response.data.seses;
                    });
            },
            addPresentAddressModal(ses_id) {
                this.btn_edit = false;
                this.present_address = {};
                this.present_address.ses_id = ses_id;
                this.$root.$emit("bv::show::modal", "add-present-address");
            },
            updatePresentAddressModal(present_address, ses_id) {
                this.btn_edit = true;
                this.present_address = {};
                http.get("api/ses/present-addresses/" + present_address.id + "/edit")
                    .then(resource => {
                        this.present_address = resource.data.present_address
                    })
                    .catch(error => console.log(error))
                this.$root.$emit("bv::show::modal", "add-present-address");
            },
            deletePresentAddress(present_address_id) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/ses/present-addresses/" + present_address_id).then(response => {
                        if (!response.error) {
                            if(response.data.error === true){
                                this.$bvToast.toast(response.data.message, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            }else{
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.search();
                            }
                        } else {
                            this.$bvToast.toast("Deleted Failed", {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        }
                    });
                }
            },
        },
        computed: {
          upazilas() {
            const district_id = this.search_data.district_id
            return (district_id)
                ? this.all_upazilas.filter(x => x.district_id === district_id)
                : null
          },
          unions() {
            const upazila_id = this.search_data.upazila_id
            return (upazila_id)
                ? this.all_unions.filter(x => x.upazila_id === upazila_id)
                : null
          },
          mouzas() {
            const union_id  = this.search_data.union_id
            return (union_id )
                ? this.all_mouzas.filter(x => x.union_id === union_id )
                : null
          },
          villages() {
            const mouza_id  = this.search_data.mouza_id
            return (mouza_id)
                ? this.all_villages.filter(x => x.mouza_id === mouza_id)
                : null
          },
        },
    };
</script>
<style src="vue-select/dist/vue-select.css"></style>
